import { connect } from 'react-redux'
import MovementCertificateNumberWidget from '../manage/MovementCertificateNumberWidget'
import * as processSelector from "../../../process/state/instance-detail/selector";
import * as processAction from "../../../process/state/instance-detail/action";

const mapStateToProps = (state, props) => {
    return {
        context: processSelector.selectProcessContext(state),
    }
}

const mapDispatchToProps = {
    changeProcessContext: processAction.changeProcessContext,
    saveProcessContext: processAction.saveProcessContext,
}

export default connect(mapStateToProps, mapDispatchToProps)(MovementCertificateNumberWidget)



// WEBPACK FOOTER //
// ./src/modules/invoice/component/task-widget/MovementCertificateNumberWidgetContainer.js